module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/4_37ee9a09a4268064c9227d45a274eec7.png";